var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.50421 1.38371C3.82206 1.09475 4.30748 1.09475 4.62533 1.38371L7.55866 4.05038C7.89921 4.35996 7.92431 4.887 7.61472 5.22755C7.30513 5.5681 6.77809 5.5932 6.43754 5.28361L4.8981 3.88412V14.0003C4.8981 14.4606 4.52501 14.8337 4.06477 14.8337C3.60453 14.8337 3.23144 14.4606 3.23144 14.0003V3.88412L1.692 5.28361C1.35145 5.5932 0.824407 5.5681 0.514818 5.22755C0.205229 4.887 0.230326 4.35996 0.570874 4.05038L3.50421 1.38371ZM11.9351 1.16699C12.3953 1.16699 12.7684 1.54009 12.7684 2.00033V12.1165L14.3079 10.717C14.6484 10.4075 15.1754 10.4325 15.485 10.7731C15.7946 11.1136 15.7695 11.6407 15.429 11.9503L12.4956 14.6169C12.1778 14.9059 11.6924 14.9059 11.3745 14.6169L8.44119 11.9503C8.10064 11.6407 8.07554 11.1136 8.38513 10.7731C8.69472 10.4325 9.22176 10.4075 9.56231 10.717L11.1017 12.1165V2.00033C11.1017 1.54009 11.4748 1.16699 11.9351 1.16699Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_3075_66347)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.00268555,
  width: 16,
  height: 16,
  fill: "#00538F"
}));

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3075_66347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.2241edb7.svg";
export { ForwardRef as ReactComponent };